export default function StatusBadge({
  status,
}) {

  const colors = {
    published:
      "bg-green-500/20 text-green-400",

    draft:
      "bg-yellow-500/20 text-yellow-400",

    archived:
      "bg-red-500/20 text-red-400",
  };

  return (
    <span
      className={`
        px-3
        py-1
        rounded-full
        text-xs
        font-semibold
        ${colors[status]}
      `}
    >
      {status}
    </span>
  );
}